import {Injectable} from '@angular/core';
import {Platform} from '@ionic/angular';
import {App} from '@capacitor/app';
import packageInfo from '../../../package.json';

import {WebService} from './web.service';
import {PlatformService} from './platform.service';

@Injectable({
	providedIn: 'root'
})
export class VersionService {

	constructor(private webService: WebService, private platform: Platform, private platformService: PlatformService) {
	}

	async isAppVersionOutdated() {
		try {
			let param;
			if (this.platformService.isDesktop) {
				param = 'desktop';
			} else {
				if (this.platform.is('android')) {
					param = 'android';
				} else {
					param = 'ios';
				}
			}

			const conf = {
				url: '/api/config/appversion/' + param
			};
			const result: any = await this.webService.unauthGet(conf);
			if (result?.data?.value) {
				let info;
				if (this.platformService.isDesktop) {
					info = {
						version: packageInfo.version
					};
				} else {
					info = await App.getInfo();
				}
				if (info.version != null && info.version !== '' && result.data.value !== '') {
					const minVersionSplit = result.data.value.split('.');
					let minVersion = '';
					for (const i in minVersionSplit) {
						if (minVersionSplit[i].length === 1) {
							minVersion += '0' + minVersionSplit[i];
						} else {
							minVersion += minVersionSplit[i];
						}
					}
					const curVersionSplit = info.version.split('.');
					let curVersion = '';
					for (const i in curVersionSplit) {
						if (curVersionSplit[i].length === 1) {
							curVersion += '0' + curVersionSplit[i];
						} else {
							curVersion += curVersionSplit[i];
						}
					}
					return minVersion > curVersion;
				} else {
					return false;
				}
			} else {
				return false;
			}
		} catch (e) {
			return false;
		}
	}

	async getAppVersion() {
		if (this.platformService.isDesktop) {
			return packageInfo.version;
		} else {
			const info = await App.getInfo();
			return info.version;
		}
	}
}
